import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateApplication,
  CreateJobListing,
  CreateJobTitle,
  CreateMetrics,
  CreateQualifications,
  CreateSkills,
  GetApplication,
  GetDepartment,
  GetJobTitle,
  GetQualifications,
  GetSkills,
  GetUnits,
} from "../../../../../utils/redux/HR/HRSlice";
import Select from "react-select";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { useGetJobRoleQuery } from "../../../../api/hrApi";

function SetupJobTitle() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [approvalStatus, setApprovalStatus] = useState(null);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10000);
  const [pageNumber, setPageNumber] = useState(1);
  const [action, setAction] = useState();

  const getRequest = useSelector((state) => state?.hr);
  const { get_department } = getRequest;

  console.log("My Department", get_department);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const start =
    startDate === undefined ? "" : format(new Date(startDate), "DD/MM/YYYY");
  const end =
    endDate === undefined ? "" : format(new Date(endDate), "DD/MM/YYYY");

  const department = get_department?.responseObject.pageItems;

  console.log("My Next Department", department);

  const apiData = {
    pageSize: pageSize,
    pageNumber: pageNumber,
    startDate: start,
    endDate: end,
    action: action,
    search: search,
  };
  useEffect(() => {
    if (approvalStatus !== null) {
      apiData["approvalStatus"] = approvalStatus;
    }
    if (search !== null && search !== "" && search !== " ") {
      apiData["search"] = search;
    }

    dispatch(GetDepartment(apiData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    approvalStatus,
    pageNumber,
    pageSize,
    search,
    startDate,
    endDate,
    action,
  ]);

  const [jobTitle, setJobTitle] = useState("");

  const [jobResponsibilities, setJobResponsibilities] = useState([
    { jobDescription: "" },
  ]);
  const [formData, setFormData] =
    useState(/* Your initial form data structure */);

  const addJobResponsibility = () => {
    setJobResponsibilities([...jobResponsibilities, { jobDescription: "" }]);
  };

  const removeJobResponsibility = (index) => {
    const updatedResponsibilities = [...jobResponsibilities];
    updatedResponsibilities.splice(index, 1);
    setJobResponsibilities(updatedResponsibilities);
  };

  const handleJobResponsibilityChange = (index, value) => {
    const updatedResponsibilities = [...jobResponsibilities];
    updatedResponsibilities[index].jobDescription = value;
    setJobResponsibilities(updatedResponsibilities);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "departmentId" ? parseInt(value, 10) : value,
    }));
  };

  const resetForm = () => {
    // Reset the form data as needed
    setJobTitle("");
    setJobResponsibilities([{ jobDescription: "" }]);
    setFormData();
  };

  const handleSubmit = () => {
    const payload = {
      title: jobTitle,
      departmentId: formData.departmentId,
      designationId: formData.designationId,
      jobResponsibilities: jobResponsibilities.map((responsibility) => ({
        jobDescription: responsibility.jobDescription.trim(),
      })),
    };

    console.log("Submitting payload:", payload);

    dispatch(CreateJobTitle(payload))
      .then((res) => {
        if (res?.payload?.successful === true) {
          console.log("blessing", formData);
          resetForm();

          setTimeout(() => {
            navigate("/dashboard/hr/recruitment-setup/");
          }, 2000);
        } else if (res?.payload?.successful === false) {
          console.log("error", res?.payload?.statusMessage);
          toast.error(res?.payload?.statusMessage);
        }
      })
      .catch((error) => {
        // Handle error, if any
        console.error("Error:", error);
      });
  };

 const { data: jobRole } = useGetJobRoleQuery({
    ApprovalStatus: 0,
    departmentId: formData?.departmentId,
    PageSize: 1000,
    PageNumber: 1,
  });
  return (
    <PageLayout title={"Setup Job Title"} hasBack={false}>
      <div className={DashboardStyle.mycontainers}>
        <div>Basic Information</div>
        <div className={DashboardStyle.secondContainer}>
          <div>
            <label>
              Job Title <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Job Title"
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
            />
          </div>

          <div>
            <label>
              Department <span>*</span>
            </label>
            <Select
              name="departmentId"
              options={
                department && department.length > 0
                  ? department.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))
                  : []
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "departmentId", value: selectedOption.value },
                })
              }
              placeholder="Select Department"
            />
          </div>

                {  formData?.departmentId &&  <div>
            <label>
            Job Role <span>*</span>
            </label>
            <Select
              name="designationId"
              options={
                jobRole && jobRole?.responseObject?.pageItems.length > 0
                  ? jobRole?.responseObject?.pageItems.map((item) => ({
                      value: item.id,
                      label: item.designationName,
                    }))
                  : []
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "designationId", value: selectedOption.value },
                })
              }
              placeholder="Select Designation"
            />
          </div>}

          {jobResponsibilities.map((responsibility, index) => (
            <div className={DashboardStyle.fullWidth} key={index}>
              <label>Job Designation (JD) </label>
              <textarea
                rows={6}
                name={`jobResponsibility${index + 1}`}
                value={responsibility.jobDescription}
                onChange={(e) =>
                  handleJobResponsibilityChange(index, e.target.value)
                }
              ></textarea>
              <button onClick={() => removeJobResponsibility(index)}>
                Remove
              </button>
            </div>
          ))}

          <div className={DashboardStyle.fullWidth}>
            <p
              style={{ color: "green", cursor: "pointer" }}
              onClick={addJobResponsibility}
            >
              + Add Job Description
            </p>
          </div>
        </div>
      </div>

      <div className={DashboardStyle.mycontainbutt}>
        <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={DashboardStyle.whiteButton}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </div>
    </PageLayout>
  );
}

function SetupSkills() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [formData, setFormData] =
    useState(/* Your initial form data structure */);

  const resetForm = () => {
    // Reset the form data as needed
    setName("");
    setDescription("");
    setFormData();
  };

  const handleSubmit = () => {
    if (!name || !description) {
      toast.error("Please fill all required fields");
      return;
    }
    const payload = {
      name: name,
      description: description,
    };

    dispatch(CreateSkills(payload))
      .then((res) => {
        if (res?.payload?.successful === true) { 
          resetForm();

          setTimeout(() => {
            navigate("/dashboard/hr/set-skills/");
          }, 2000);
        } else if (res?.payload?.successful === false) {
          console.log("error", res?.payload?.message);
          toast.error(res?.payload?.statusMessage);
        }
      })
      .catch((error) => {
        // Handle error, if any
        console.error("Error:", error);
      });
  };

  return (
    <PageLayout title={"Setup Skills"} hasBack={false}>
      <div className={DashboardStyle.mycontainers}>
        <div>Basic Information</div>
        <div className={DashboardStyle.secondContainer}>
          <div>
            <label>
              Skill Name <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Skill Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className={DashboardStyle.fullWidth}>
            <label>Skill Description </label>
            <textarea
              rows={6}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            >
              Enter Skill Description
            </textarea>
          </div>
        </div>
      </div>

      <div className={DashboardStyle.mycontainbutt}>
        <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={DashboardStyle.whiteButton}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </div>
    </PageLayout>
  );
}

function SetupQualification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [qualification, SetupQualification] = useState("");
  const [description, setDescription] = useState("");
  const [formData, setFormData] =
    useState(/* Your initial form data structure */);

  const resetForm = () => {
    // Reset the form data as needed
    SetupQualification("");
    setDescription("");
    setFormData();
  };

  const handleSubmit = () => {
    const payload = {
      qualification: qualification,
      description: description,
    };


    dispatch(CreateQualifications(payload))
      .then((res) => {
        if (res?.payload?.successful === true) {
          console.log("blessing", formData);
          resetForm();

          setTimeout(() => {
            navigate("/dashboard/hr/qualification-setup/");
          }, 2000);
        }
      })
      .catch((error) => {
        // Handle error, if any
        console.error("Error:", error);
      });
  };

  return (
    <PageLayout title={"Setup Qualifications"} hasBack={false}>
      <div className={DashboardStyle.mycontainers}>
        <div>Basic Information</div>
        <div className={DashboardStyle.secondContainer}>
          <div>
            <label>
              Course Name <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Course Name"
              value={qualification}
              onChange={(e) => SetupQualification(e.target.value)}
            />
          </div>
          <div className={DashboardStyle.fullWidth}>
            <label>Qualification Description </label>
            <textarea
              rows={6}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            >
              Enter Description
            </textarea>
          </div>
        </div>
      </div>

      <div className={DashboardStyle.mycontainbutt}>
        <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={DashboardStyle.whiteButton}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </div>
    </PageLayout>
  );
}

function MetricsSetup() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [rate, setRate] = useState("");
  const [formData, setFormData] =
    useState(/* Your initial form data structure */);

  const resetForm = () => {
    // Reset the form data as needed
    setName("");
    setRate("");
    setFormData();
  };

  const handleSubmit = () => {
    const payload = {
      name: name,
      rate: rate,
    };

    console.log("Submitting payload:", payload);

    dispatch(CreateMetrics(payload))
      .then((res) => {
        if (res?.payload?.successful === true) {
          console.log("blessing", formData);
          resetForm();

          setTimeout(() => {
            navigate("/dashboard/hr/metrics-setup/");
          }, 2000);
        } else if (res?.payload?.successful === false) {
          toast.error(res?.payload?.statusMessage);
        }
      })
      .catch((error) => {
        // Handle error, if any
        console.error("Error:", error);
      });
  };

  return (
    <PageLayout title={"Setup Metrics Command"} hasBack={false}>
      <div className={DashboardStyle.mycontainers}>
        <div>Basic Information</div>
        <div className={DashboardStyle.secondContainer}>
          <div>
            <label>
              Metric Name <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Metric Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <label>
              Rate <span>*</span>
            </label>
            <input
              type="number"
              placeholder="Enter Rate"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className={DashboardStyle.mycontainbutt}>
        <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={DashboardStyle.whiteButton}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </div>
    </PageLayout>
  );
}

function SetApplicationChannel() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [channel, setChannel] = useState("");
  const [formData, setFormData] =
    useState(/* Your initial form data structure */);

  const resetForm = () => {
    // Reset the form data as needed
    setChannel("");
    setFormData();
  };

  const handleSubmit = () => {
    const payload = {
      channel: channel,
    };

    console.log("Submitting payload:", payload);

    dispatch(CreateApplication(payload))
      .then((res) => {
        if (res?.payload?.successful === true) {
          console.log("blessing", formData);
          resetForm();

          setTimeout(() => {
            navigate("/dashboard/hr/application-channel-setup/");
          }, 2000);
        }
      })
      .catch((error) => {
        // Handle error, if any
        console.error("Error:", error);
      });
  };

  return (
    <PageLayout title={"Setup Application Channel"} hasBack={false}>
      <div className={DashboardStyle.mycontainers}>
        <div>Basic Information</div>
        <div className={DashboardStyle.secondContainer}>
          <div className={DashboardStyle.fullWidth}>
            <label>
              Channel <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Channel"
              value={channel}
              onChange={(e) => setChannel(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className={DashboardStyle.mycontainbutt}>
        <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={DashboardStyle.whiteButton}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </div>
    </PageLayout>
  );
}

function SetupJobListing() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [channel, setChannel] = useState("");

  const getRequest = useSelector((state) => state?.hr);
  const { job_title } = getRequest;

  const getRequest2 = useSelector((state) => state?.hr);
  const { get_skills } = getRequest2;

  const getRequest3 = useSelector((state) => state?.hr);
  const { get_qualifications } = getRequest3;

  const getRequest4 = useSelector((state) => state?.hr);
  const { get_application } = getRequest4;

  const getRequest5 = useSelector((state) => state?.hr);

  // console.log("getRequest5", getRequest5?.units?.responseObject?.pageItems);

  // Initial form data structure
  const initialFormData = {
    jobTitleId: 0,
    containerId: 0,
    yearsOfExperience: "",
    openingDate: new Date().toISOString(), // Assuming you want to set opening date to current date and time
    closingDate: new Date().toISOString(), // Assuming you want to set closing date to current date and time
    skillIds: [0],
    qualificationIds: [0],
    channelIds: [0],
  };

  const [formData, setFormData] = useState(initialFormData);

  const resetForm = () => {
    setChannel("");
    setFormData(initialFormData); // Reset form data to initial state
  };

  const handleSubmit = () => {
    const payload = {
      ...formData,
      channel: channel,
    };

    // console.log("Submitting payload:", payload);

    dispatch(CreateJobListing(payload))
      .then((res) => {
        if (res?.payload?.successful === true) {
          // console.log("blessing", formData);
          // setTimeout(() => {
          //   navigate("/dashboard/hr/joblist-setup");
          // }, 2000);
          toast.success(res?.payload?.message);
          navigate("/dashboard/hr/joblist-setup");
          resetForm();
        } else {
          toast.error(res?.payload?.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const apiData = {
    pageSize: 10000,
    pageNumber: 1,
  };

  useEffect(() => {
    dispatch(GetJobTitle(apiData));
    dispatch(GetSkills(apiData));
    dispatch(GetQualifications(apiData));
    dispatch(GetApplication(apiData));
    dispatch(GetUnits(apiData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageLayout title={"Setup Job Listing Channel"} hasBack={false}>
      <div className={DashboardStyle.mycontainers}>
        <div>Basic Information</div>
        <div className={DashboardStyle.secondContainer}>
          <div className={DashboardStyle.fullWidth}>
            <label>
              Job Title <span>*</span>
            </label>
            <select
              className={DashboardStyle.myselect}
              onChange={(e) =>
                setFormData({ ...formData, jobTitleId: e.target.value })
              }
            >
              <option value="">Select Job Title</option>
              {job_title?.responseObject?.pageItems?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.title}
                </option>
              ))}
            </select>
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Years of Experience <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter years of experience"
              className={DashboardStyle.myinput}
              value={formData.yearsOfExperience}
              onChange={(e) =>
                setFormData({ ...formData, yearsOfExperience: e.target.value })
              }
            />
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Opening Date <span>*</span>
            </label>
            <input
              type="date"
              className={DashboardStyle.myinput}
              value={formData.openingDate}
              onChange={(e) =>
                setFormData({ ...formData, openingDate: e.target.value })
              }
            />
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Closing Date <span>*</span>
            </label>
            <input
              type="date"
              className={DashboardStyle.myinput}
              value={formData.closingDate}
              onChange={(e) =>
                setFormData({ ...formData, closingDate: e.target.value })
              }
            />
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Skill <span>*</span>
            </label>
            <select
              className={DashboardStyle.myselect}
              onChange={(e) =>
                setFormData({ ...formData, skillIds: [e.target.value] })
              }
            >
              <option value="">Select Skill</option>
              {get_skills?.responseObject?.pageItems?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Qualification <span>*</span>
            </label>
            <select
              className={DashboardStyle.myselect}
              onChange={(e) =>
                setFormData({ ...formData, qualificationIds: [e.target.value] })
              }
            >
              <option value="">Select Qualification</option>
              {get_qualifications?.responseObject?.pageItems?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.qualification}
                </option>
              ))}
            </select>
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Channel <span>*</span>
            </label>
            <select
              className={DashboardStyle.myselect}
              onChange={(e) => setChannel(e.target.value)}
            >
              <option value="">Select Channel</option>
              {get_application?.result?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.channel}
                </option>
              ))}
            </select>
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Managing Container<span>*</span>
            </label>
            <select
              className={DashboardStyle.myselect}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  containerId: Number(e.target.value),
                })
              }
            >
              <option value="" disabled>
                Select Managing Container
              </option>
              {/* <option value={0}>ManagingDirector</option>
                <option value={1}>BoardOfTrustees</option>
                <option value={2}>Directorate</option>
                <option value={3}>Department</option>
                <option value={4}>Unit</option>
                <option value={5}>Zone</option>
                <option value={6}>Branch</option>
                <option value={7}>ServiceCenter</option> */}
              {getRequest5?.units?.responseObject?.pageItems?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className={DashboardStyle.mycontainbutt}>
        <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={DashboardStyle.whiteButton}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </div>
    </PageLayout>
  );
}

export default function GeneralSetup() {
  return (
    <PageLayout isMain={true} title={"HR Services Setup"} hasBack={true}>
      <SetupJobTitle />
      {/* <div className="border-b border-neutral-100 pt-4 mb-2"/> */}
      <SetupSkills />
      <SetupQualification />
      <MetricsSetup />
      <SetApplicationChannel />
      <SetupJobListing />
    </PageLayout>
  );
}
